import { useEffect, useMemo, useState } from 'react';
import { formatTime } from '@shared/format.js';

export default function CalendarView({ days, month }) {
  const [ym, setYm] = useState(() => {
    const d = new Date();
    return { y: d.getFullYear(), m: d.getMonth() + 1 };
  });

  // 当外部传入 month (YYYY-MM) 时同步
  useEffect(() => {
    if (!month) return;
    const [y, m] = month.split('-').map(Number);
    setYm({ y, m });
  }, [month]);

  const cells = useMemo(() => {
    const first = new Date(ym.y, ym.m - 1, 1);
    const startWeekday = first.getDay(); // 0=周日
    const daysInMonth = new Date(ym.y, ym.m, 0).getDate();
    const arr = [];
    for (let i = 0; i < startWeekday; i++) arr.push(null);
    for (let d = 1; d <= daysInMonth; d++) {
      const key = `${ym.y}-${String(ym.m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      arr.push({ day: d, key, info: days?.[key] || null });
    }
    return arr;
  }, [ym, days]);

  const checkedDays = Object.keys(days || {}).length;
  const today = new Date();
  const isCurrent = today.getFullYear() === ym.y && today.getMonth() + 1 === ym.m;

  const nav = (delta) => {
    let m = ym.m + delta;
    let y = ym.y;
    if (m < 1) { m = 12; y--; }
    if (m > 12) { m = 1; y++; }
    setYm({ y, m });
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <button onClick={() => nav(-1)} className="text-slate-500 hover:text-accent px-2 py-1">‹</button>
        <div className="text-sm font-semibold text-slate-200">
          {ym.y} 年 {ym.m} 月
          <span className="ml-2 text-xs font-normal text-slate-500">打卡 {checkedDays} 天</span>
        </div>
        <button onClick={() => nav(1)} className="text-slate-500 hover:text-accent px-2 py-1">›</button>
      </div>

      <div className="grid grid-cols-7 gap-1 text-center text-[11px] text-slate-500 mb-1.5">
        {['日', '一', '二', '三', '四', '五', '六'].map((w) => (
          <div key={w} className="py-1">{w}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((c, i) =>
          c === null ? (
            <div key={`e${i}`} />
          ) : (
            <div
              key={c.key}
              className={`relative rounded-lg aspect-square flex flex-col items-center justify-center text-sm transition-colors ${
                c.info
                  ? 'bg-accent/15 text-accent cursor-default hover:bg-accent/25'
                  : 'text-slate-600'
              } ${isCurrent && c.day === today.getDate() ? 'ring-1 ring-accent/70' : ''}`}
              title={
                c.info
                  ? `${c.key}\n${c.info.count} 把 · 最佳 ${formatTime(c.info.best)} · 平均 ${c.info.avg != null ? formatTime(c.info.avg) : '—'}`
                  : c.key
              }
            >
              <span>{c.day}</span>
              {c.info && (
                <span className="text-[9px] leading-none mt-0.5">
                  {c.info.count}把
                </span>
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
}
